module.exports = __webpack_public_path__ + "img/location.8f002994.svg";